export default "__VITE_ASSET__CJ2xu51g__"